import { css, cx } from '@/styled-system/css'
import { splitCssProps } from '@/styled-system/jsx'
import {
  iconButton,
  type IconButtonVariantProps,
} from '@/styled-system/recipes'
import type { Assign, JsxStyleProps } from '@/styled-system/types'
import { ForwardedRef, forwardRef, type ButtonHTMLAttributes } from 'react'
import Spinner from '../design-system/spinner'

export interface IconButtonProps
  extends Assign<JsxStyleProps, ButtonHTMLAttributes<HTMLButtonElement>>,
    IconButtonVariantProps {}

export const IconButton = forwardRef<HTMLElement, IconButtonProps>(
  (props, ref) => {
    const [variantProps, checkboxProps] = iconButton.splitVariantProps(props)
    const [cssProps, localProps] = splitCssProps(checkboxProps)
    const { children, className, disabled, ...rest } = localProps
    const styles = iconButton(variantProps)

    return (
      <button
        ref={ref as ForwardedRef<HTMLButtonElement>}
        className={cx(styles.root, css(cssProps), className)}
        disabled={disabled}
        {...rest}
      >
        {children}

        <span className={styles.loadingIndicator}>
          <Spinner />
        </span>
      </button>
    )
  }
)

IconButton.displayName = 'IconButton'
